export default class ImagePreloader {
	static images = {};

	static preload(key, url) {
		if (key in ImagePreloader.images) console.warn('overwriting ImagePreloader key: ', key)
		const image = new Image();
    image.src = url;
    ImagePreloader.images[key] = image;
    image.decode()
    .then(() => {
    	ImagePreloader.images[key] = image;
    })
    .catch((error) => {
      console.error(error, error.toString());
    });
	}
}